// import Util from '@/helper/Utility';
export default function CreateQRModel() {
        this.source = null;
        this.target = null;
        this.branchId = null;
        this.appId = null;
        this.amount = null;
        this.cardId = null;
        this.callbackUrl = null;
        this.isDeductBzbsApp = false;

    this.setDataFromObject = function(data) {
        this.source = data.source || this.source;
        this.target = data.target || this.target;
        this.branchId = data.branchId || this.branchId;
        this.appId = data.appId || this.appId;
        this.amount = data.amount || this.amount;
        this.cardId = data.cardId || this.cardId;
        this.callbackUrl = data.callbackUrl || this.callbackUrl;
        this.isDeductBzbsApp = data.isDeductBzbsApp || this.isDeductBzbsApp;
    }

    this.getParams = function() {
        return {
            source: this.source,
            target: this.target,
            branchId: this.branchId,
            appId: this.appId,
            amount: this.amount,
            cardId: this.cardId,
            callbackUrl: this.callbackUrl,
            isDeductBzbsApp: this.isDeductBzbsApp,
        };
    }
}

export function genQrModel() {
    this.serial = "";
    this.expireIn = "";
    this.referenceQrId = "";
    this.showTimer = false;

    this.setDataFromApi = function (data) {
        this.serial = data.qr;
        this.expireIn = data.expireTime;
        this.referenceQrId = data.referenceQrId;
        if(this.expireIn != ""){
            this.showTimer = true;
        }
    };
}
